// 
import partialUpdateDefaultSettings from './defaultSettings';
import { getDataSet } from '../lib/dataset';
import { getTargets } from './partialUpdateUtils';

/**
 Definice nastavení Partial Updatu.

 Data atributy ze kterých se parsují settings.

 Klíč je data atribut a hodnota určuje o jakou vlastnost nastavení se jedná:
 <pre>{
  'data-partial-update-request-target': 'requestTarget',
  'data-pu-request-target': 'requestTarget',
  'data-partial-update-target-html-container': 'requestTarget',
  'data-pu-target-html-container': 'requestTarget',
  'data-partial-update-target': 'target',
  'data-pu-target': 'target',
  'data-partial-update-widget': 'target',
  'data-pu-widget': 'target',
  'data-partial-update-command': 'eventName',
  'data-pu-command': 'eventName',
  'data-partial-update-event-name': 'eventName',
  'data-pu-event-name': 'eventName',
  'data-partial-update-data': 'data',
  'data-pu-data': 'data',
  'data-partial-update-url': 'url',
  'data-pu-url': 'url',
  'data-partial-update-alter-history': 'alterHistory',
  'data-pu-alter-history': 'alterHistory',
  'data-partial-update-settings': 'settings',
  'data-pu-settings': 'settings',
  }</pre>
 */

window.partialUpdateGlobalSettings = {
  ...partialUpdateDefaultSettings,
};
export const getGlobalPartialUpdateSettings = () =>
  window.partialUpdateGlobalSettings;

/**
 * Na defaultní nastavení pro celí projekt
 */
export const setPartialUpdateDefaultSettings = (settings) => {
  window.partialUpdateGlobalSettings = {
    ...partialUpdateDefaultSettings,
    ...settings,
  };
};

export const settingsDataAttributesMap = {
  'data-partial-update-request-target': 'requestTarget',
  'data-pu-request-target': 'requestTarget',
  'data-partial-update-target-html-container': 'requestTarget',
  'data-pu-target-html-container': 'requestTarget',
  'data-partial-update-target': 'target',
  'data-pu-target': 'target',
  'data-partial-update-widget': 'target',
  'data-pu-widget': 'target',
  'data-partial-update-command': 'eventName',
  'data-pu-command': 'eventName',
  'data-partial-update-event-name': 'eventName',
  'data-pu-event-name': 'eventName',
  'data-partial-update-data': 'data',
  'data-pu-data': 'data',
  'data-partial-update-url': 'url',
  'data-pu-url': 'url',
  'data-partial-update-alter-history': 'alterHistory',
  'data-pu-alter-history': 'alterHistory',
  'data-partial-update-data-merge': 'dataMerge',
  'data-pu-data-merge': 'dataMerge',
  // nechat na konci. Settings se mergují do všech nasbíraných
  'data-partial-update-settings': 'settings',
  'data-pu-settings': 'settings',
};

export const getElementPartialUpdateSettings = (element) => {
  let settings = {};
  if (element) {
    Object.keys(settingsDataAttributesMap)
      .forEach((dataset) => {
        const prop = settingsDataAttributesMap[dataset];
        const datasetValue = getDataSet(element, dataset.replace(/^data-/, ''));
        if (datasetValue != null) {
          if (prop === 'settings') {
            settings = {
              ...settings,
              ...datasetValue,
            };
          } else {
            settings[prop] = datasetValue;
          }
        }
      });
  }
  return settings;
};


// Přečte nastavení partial update ze všech closest
// elementů a mergne je do sebe
// - excludePartialUpdateContainerSettings - pokud je true,
// tak vynechá všechna nastavení z parentího partial update containeru
// - excludePartialUpdateContainerSettings - pokud je Array<String>,
// tak vynechá jen specifikovaná nastavení z parentího partial update containeru
export const getClosestPartialUpdateSettings = (
  settings,
  excludePartialUpdateContainerSettings,
) => {
  let targetElement;
  let mergeWithTargetSettings;
  let closestSettings = {};

  if (settings instanceof HTMLElement) {
    targetElement = settings;
  } else {
    const {
      submitId,
    } = settings;
    mergeWithTargetSettings = settings.mergeWithTargetSettings;
    const firstTarget = getTargets(settings)[0];
    targetElement = document.getElementById(firstTarget || submitId);
  }

  const startClosestElement = mergeWithTargetSettings == null || mergeWithTargetSettings === true ?
    targetElement : targetElement.parentElement;

  if (targetElement) {
    Object.keys(settingsDataAttributesMap)
      .forEach((dataset) => {
        const prop = settingsDataAttributesMap[dataset];
        let closestDatasetElement;
        if (excludePartialUpdateContainerSettings) {
          if (Array.isArray(excludePartialUpdateContainerSettings)) {
            if (excludePartialUpdateContainerSettings.includes(prop)) {
              closestDatasetElement = startClosestElement.closest(
                `[${dataset}]:not(.isPartialUpdateContainer)`);
            } else {
              closestDatasetElement = startClosestElement.closest(`[${dataset}]`);
            }
          } else {
            closestDatasetElement = startClosestElement.closest(
              `[${dataset}]:not(.isPartialUpdateContainer)`);
          }
        } else {
          closestDatasetElement = startClosestElement.closest(`[${dataset}]`);
        }
        if (closestDatasetElement) {
          const datasetValue = getDataSet(closestDatasetElement, dataset.replace(/^data-/, ''));
          if (prop === 'settings') {
            closestSettings = {
              ...closestSettings,
              ...datasetValue,
            };
          } else {
            closestSettings[prop] = datasetValue;
          }
        }
      });
  }
  return closestSettings;
};

export const getPaginationSubmitData = (
  settings,
) => {
  let element;

  if (settings instanceof HTMLElement) {
    element = settings;
  } else {
    const {
      submitId,
    } = settings;
    const firstTarget = getTargets(settings)[0];
    element = document.getElementById(firstTarget || submitId);
  }
  // jestliže je uvnitř widgetu pagination widget,
  // tak z něj získá aktuální počet načtených stránek
  // a obsah refreshne s parametrem pageSize
  const pagination = element.querySelector('[data-fragment="pagination"]');
  const data = [];
  if (pagination) {
    const paginationProps = getDataSet(pagination);
    const {
      loadedPagesParameterName,
      loadedPages,
      pageSize,
      pageSizeParameterName,
      pageNumber,
      pageNumberParameterName,
    } = paginationProps;

    if (loadedPagesParameterName && loadedPages != null && pageSize != null && pageNumber != null) {
      data.push({
        name: pageSizeParameterName,
        value: pageSize * (loadedPages),
      });
      data.push({
        name: pageNumberParameterName,
        value: (pageNumber - loadedPages) + 1,
      });
    }
  }
  return data;
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/partialUpdate/PartialUpdateSettings.js